import type { ConfigurationSection, ConfigurationSetup } from '@/teoCore/config/config-setup.types';
import { isError } from '@/teoCore/errors/TeoError';
import type { AnalysisConfiguration } from '@/teoCore/text/TeoText';
import type { TeoPDF } from '@/utils/teo-pdf/TeoPDF';

export function renderAnalyseKonfiguration(
  pdf: TeoPDF,
  configuration: Maybe<Partial<AnalysisConfiguration>>,
  configSetup: Maybe<ConfigurationSetup<ConfigurationSection>> | Error,
) {
  if (!configuration || !configSetup || isError(configSetup)) {
    return pdf.addSection('Analyse-Konfiguration', (pdf) =>
      pdf.addText('Keine Analyse-Konfiguration vorhanden'),
    );
  }

  const entries = configSetup.sections.map((section) => {
    const sectionId = getConfigurationId(configuration, section);
    const option = section.options.find((option) => option.id === sectionId);
    return [section.title, option?.label ?? ''];
  });
  pdf.setFontSize(12);
  const maxWidthTitle = pdf.getMaxTextWidth(entries.map(([title]) => title));
  const maxWidthOption = pdf.getMaxTextWidth(entries.map(([, option]) => option));

  return pdf.addSection('Analyse-Konfiguration', (pdf) =>
    pdf.setFontSize(12).createTable({
      defaultStyle: {
        border: 0,
      },
      columnStyles: [maxWidthTitle + 12, maxWidthOption + 12],
      createRows: () => {
        const rows = configSetup.sections.map((section) => {
          const sectionId = getConfigurationId(configuration, section);
          const option = section.options.find((option) => option.id === sectionId);
          return [section.title, option?.label ?? ''];
        });
        return rows;
      },
    }),
  );
}

function getConfigurationId(
  configuration: Partial<AnalysisConfiguration>,
  section: ConfigurationSection,
) {
  if (section.id in configuration) {
    return configuration[section.id as keyof AnalysisConfiguration];
  }
  return null;
}
